import * as React from 'react';
import { FavouriteDefinition } from 'app/types-shared';
import { STATE } from 'app/constants';
import { SimpleFormAreaState } from 'app/infrastructure/simple-form/types';
import { mapToFilterList } from './filters-mapping';
import { mapToDisplaySelectedOptions } from './mapping';
import { filtersTranslations } from './constants';
import { createFilteredValues } from 'app/area/filters/filters-mapping';
import { DisplaySelectedOptions } from 'app/components/display-selected-options/display-selected-options';
import { DrawerWithBar } from 'ui';
import { FiltersContainer } from 'app/area/filters/filters';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { useSelector } from 'react-redux';
import { selectCurrentList } from 'app/area/filters/selectors';
import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { useInstanceSimpleForm } from 'app/area/filters/hooks';
import { ReactNode } from 'react';

export interface FiltersDrawerProps {
  simpleForm?: SimpleFormAreaState;
  validation?: { [key: string]: any };
  title?: string;
  definition: FavouriteDefinition;
  hideDisclaimerMessage?: boolean;
  initiallyOpen?: boolean;
  updateDefinition: (transform?: (definition: FavouriteDefinition) => FavouriteDefinition) => void;
  children: ReactNode;
}

export function FiltersDrawer({
  hideDisclaimerMessage,
  definition,
  updateDefinition,
  title,
  initiallyOpen,
  children
}: FiltersDrawerProps) {

  const instanceKey = useInstanceKey();

  const sharedState = useSharedState();

  const translation = useTranslation(STATE.filters, filtersTranslations);

  const {
    simpleForm,
    validation
  } = useInstanceSimpleForm();

  const currentList = useSelector(selectCurrentList(instanceKey));
  
  const values = simpleForm?.editing?.values;

  const filteredValues = values && createFilteredValues(values, validation);

  const filterList = mapToFilterList(
    currentList,
    filteredValues,
    translation,
    sharedState.locale
  );

  const dropdownOptions = mapToDisplaySelectedOptions(filterList, translation, sharedState.locale);

  const summary = <DisplaySelectedOptions
    selectedOptions={dropdownOptions}
    textHideDetails={translation.hide_details}
    textShowDetails={translation.show_details}
  />;

  const drawerContent = <FiltersContainer
    definition={definition}
    updateDefinition={updateDefinition}>
    {!hideDisclaimerMessage && translation.disclaimer_message}
  </FiltersContainer>;

  const filterCountInidicator = dropdownOptions.length ? ` (${dropdownOptions.length})` : '';

  return <DrawerWithBar
    title={`${title}${filterCountInidicator}`}
    barContent={summary}
    drawerContent={drawerContent}
    initiallyOpen={initiallyOpen}>
    {children}
  </DrawerWithBar>;
}
